import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import { notificationsConfig } from '../../../../../config/constants';
import { useFarmId } from '../../../InventoryWidget/useFarmId';
import { useDeviationsAPI } from './useDeviationsAPI';
import { alertQueryKeysMap } from './useDeviationAlertsQuery';
import { deviationSummaryKeysMap } from './useDeviationAlertsSummaryQuery';
export const useAlertsMutation = (widgetType) => {
    const api = useDeviationsAPI(widgetType);
    const client = useQueryClient();
    const dispatch = useDispatch();
    const farmId = useFarmId();
    return useMutation({
        mutationFn: (ids) => api.deleteAlerts(farmId, ids),
        onSuccess: () => {
            client.invalidateQueries({ queryKey: alertQueryKeysMap[widgetType] });
            client.invalidateQueries({ queryKey: deviationSummaryKeysMap[widgetType] });
        },
        onError: () => {
            dispatch(error({
                ...notificationsConfig.defaultConf,
                translationKey: 'widget:widget:cant_update_widgets',
            }));
        },
    });
};
//# sourceMappingURL=useAlertsMutation.js.map